module.exports = __webpack_public_path__ + "img/close.558efb8b.svg";